import React, { Component } from 'react';
import { Modal as BTModal, Button } from 'react-bootstrap';
import './ModalStyle.scss';

class Modal extends Component {
    constructor(props) {
        super(props)
    }
    render() {

        return (
            <BTModal className={this.props.className} show={this.props.show} onHide={this.props.onHide} backdrop="static" keyboard={false}>
                {this.props.children}
            </BTModal>
        )
    }
}

const ModelHeader = (props) => {
    return (
        <BTModal.Header closeButton>
            <BTModal.Title>{props.children}</BTModal.Title>
        </BTModal.Header>
    )
}

const ModalBody = (props) => {
    return (
        <BTModal.Body>
            {props.children}
        </BTModal.Body>
    )

}

const ModalFooter = (props) => {
    return (
        <BTModal.Footer>
            {props.children}
        </BTModal.Footer>
    )

}


export { Modal, ModelHeader, ModalBody, ModalFooter };